import { useMutation } from '@tanstack/react-query';
import oaiApiClient from '../clients/oai-api/oai-api-client';
import { RegisterUserParams } from '../clients/oai-api/types/requests/RegisterUserParams';
import { RegisterUserResponse } from '../clients/oai-api/types/responses/RegisterUserResponse';
import { GetActivationTokenResponse } from '../clients/oai-api/types/responses/GetActivationTokenResponse';

type RegisterUserMutationResponse = GetActivationTokenResponse &
  RegisterUserResponse;

type Params = {
  onError?: (error: { code?: number; message?: string }) => void;
};

export const useRegisterUser = ({ onError }: Params = {}) => {
  return useMutation<
    RegisterUserMutationResponse,
    { code?: number; message?: string },
    RegisterUserParams
  >({
    mutationKey: ['register-user'],
    mutationFn: async (params) => {
      return oaiApiClient.registerUser(params);
    },
    onError,
  });
};
